import React from 'react';
import Loadable from 'react-loadable';
import otRoutes from './Modules/ot';
import customerRoutes from './Modules/customer';
import productRoutes from './Modules/product';

const Help = Loadable({
    loader: () => import('../Containers/Help/HelpContainer'),
    loading: () => {
        return (<h3>Cargando...</h3>);
    }
});

const Dashboard = Loadable({
    loader: () => import('../Components/Dashboard/SellerDashboard'),
    loading: () => {
        return (<h3>Cargando...</h3>);
    }
});

const routes = [
    ...otRoutes,
    ...customerRoutes,
    ...productRoutes,
    ...[
        { path: '/dashboard', name: 'Home', exact: true, component: Dashboard },
        { path: '/help', name: 'Ayuda', exact: true, component: Help },
    ],
];

const menu = {
    items: [
        {
            name: 'Home',
            url: '/dashboard',
            icon: 'icon-layers',
        },
        {
            name: 'Calendario',
            url: '/ot/calendar',
            icon: 'icon-layers',
        },
        {
            name: 'Ordenes',
            url: '/ot/list',
            icon: 'icon-layers',
        },
        {
            name: 'Cotizaciones',
            url: '/quote/list',
            icon: 'icon-layers',
        },
        {
            name: 'Productos',
            url: '/product/list',
            icon: 'icon-layers',
        },
        {
            name: 'Clientes',
            url: '/customer/list',
            icon: 'icon-layers',
        },
        {
            name: 'Ayuda',
            url: '/help',
            icon: 'icon-question',
        },
    ],
};

export default {
    routes,
    menu,
};



// WEBPACK FOOTER //
// ./src/Routes/seller.js